module.exports = __webpack_public_path__ + "img/chest.f4006918.png";